import StepId from "@/model/progress/StepId"

const providerKey = "hfd_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "hfdPrequalifyStart",
            path: `/providers/${providerKey}/modes/prequalify/start`,
            redirect: `/providers/${providerKey}/prequalifyAgreeNext`,
        },
        {
            name: "hfdResume",
            path: `/providers/${providerKey}/resume`,
            meta: { step: StepId.PATIENT_INFO, stepper: false },
            component: () => import("@/views/provider/hfd/HfdResumeView.vue"),
        },
        {
            name: "hfdPaymentPlanReview",
            path: `/providers/${providerKey}/paymentPlanReview`,
            meta: { step: StepId.ACCEPT_OFFER },
            extends: "paymentPlanReview",
            props: route => {
                return {
                    mpf: route.query.mpf === "true",
                }
            },
            component: () => import("@/views/provider/hfd/HfdPaymentPlanReviewView.vue"),
        },
        {
            name: "hfdMPFPaymentPlanReview",
            path: `/providers/${providerKey}/mpfPaymentPlanReview`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/hfd/HfdMPFPaymentPlanReviewView.vue"),
        },
        {
            name: "hfdDownpayment",
            path: `/providers/${providerKey}/downpayment`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/hfd/HfdDownpaymentCollectionFormView.vue"),
        },
        {
            path: `/providers/${providerKey}/terms`,
            name: "hfdTerms",
            extends: "terms",
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/hfd/HfdTermsView.vue"),
        },
        {
            path: `/providers/${providerKey}/approved`,
            name: "hfdApproved",
            extends: "approved",
            component: () => import("@/views/provider/hfd/HfdApplicationApprovedView.vue"),
        },
        {
            path: `/providers/${providerKey}/complete`,
            name: "hfdComplete",
            extends: "complete",
            component: () => import("@/views/provider/hfd/HfdApplicationApprovedView.vue"),
        },
        {
            name: "acceptOfferError",
            path: `/providers/${providerKey}/acceptOfferError`,
            component: () => import("@/views/provider/hfd/HfdTermsView.vue"),
        },
        {
            name: "hfdAdditionalContactInformation",
            path: `/providers/${providerKey}/additionalContactInformation`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/hfd/HfdAdditionalContactInformationView.vue"),
        },
        {
            name: "hfdLoanPayment",
            path: `/providers/${providerKey}/loanPayment`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/hfd/HfdLoanpaymentCollectionFormView.vue"),
        },
    ],
}
